import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorMappingService {
  private readonly DEFAULT_ENTITY_NAME = 'Die Entität';

  private statusMap = new Map<number, string>([
    [
      400, // BAD_REQUEST
      'Ungültige Anfrage. Bitte überprüfen Sie die übermittelten Daten.',
    ],
    [
      403, // FORBIDDEN (used for NotAuthorizedException & AccessDeniedException)
      'Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es später erneut. Falls der Fehler weiterhin besteht, wenden Sie sich bite an support@road-it.de',
    ],
    [
      404, // NOT_FOUND
      '{entity} wurde nicht gefunden. Eventuell wurde sie von anderen Benutzer gelöscht. Bitte aktualisieren Sie die Ansicht.',
    ],
    [
      409, // CONFLICT (AlreadyExistsException)
      '{entity} mit diesem Namen ist bereits vorhanden. Bitte wählen Sie ein anderen Namen.',
    ],
    [
      422, // UNPROCESSABLE_ENTITY (used for InvalidArgumentException & WebExchangeBindException)
      'Die Adressen der Sensoren oder deren Zuweisung zu den Messpunkten sind nicht eindeutig. Es darf keine zwei ' +
      'Sensoren mit der gleiche Adresse oder mit der gleichen Messpunkt geben. Bitte korrigieren sie diese.',
    ],
    [
      428, // PRECONDITION_REQUIRED (InvalidStateException)
      'Die Aktion kann für {entity} im aktuellen Status nicht ausgeführt werden.',
    ],
    [
      500, // INTERNAL_SERVER_ERROR
      'Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es später erneut. Falls der Fehler weiterhin besteht, wenden Sie sich bite an support@road-it.de',
    ],
  ]);

  private readonly DEFAULT_ERROR_MESSAGE =
    'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.';

  getGermanErrorMessage(error: HttpErrorResponse, entityName?: string): string {
    const entity = entityName || this.DEFAULT_ENTITY_NAME;

    if (error.error instanceof ErrorEvent) {
      return `Ein Client-Fehler ist aufgetreten: ${error.error.message}`;
    }

    if (error.status === 409 && entity === 'Benutzer') {
      return "Ein Benutzer mit dieser E-Mail Adresse ist schon registriert. Bitte wählen Sie eine andere E-Mail Adresse."
    }

    const messageTemplate = this.statusMap.get(error.status);
    if (!messageTemplate) {
      return this.DEFAULT_ERROR_MESSAGE;
    }

    return messageTemplate.replace('{entity}', entity);
  }
}
